import { render, staticRenderFns } from "./PrintPosDteLetterStandardLayout.vue?vue&type=template&id=6c5fe24b"
import script from "./PrintPosDteLetterStandardLayout.vue?vue&type=script&lang=js"
export * from "./PrintPosDteLetterStandardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports